import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  LogicalAlignment,
  PhysicalAlignment,
} from '@wix/editor-elements-common-utils';
import {
  getScaledFont,
  getBrightnessCSSVars,
  withFallbackValues,
  convertPhysicalAlignmentToLogical,
} from '@wix/editor-elements-common-utils';
import type {
  SiteButtonDefinition,
  ISiteButtonProps,
  SiteButtonCSSVars,
  SiteButtonStateValues,
} from '../SiteButton.types';

export const props = withCompInfo<
  ISiteButtonProps,
  SiteButtonDefinition,
  ISiteButtonProps
>()(
  [
    'isQaMode',
    'fullNameCompType',
    'language',
    'mainPageId',
    'compId',
    'mainPageId',
    'trackClicksAnalytics',
  ],
  (compProps, carmiData) => {
    return {
      ...carmiData,
      ...compProps,
    };
  },
);

export const css = withCompInfo<SiteButtonCSSVars, SiteButtonDefinition>()(
  [
    'compData',
    'styleProperties',
    'compProps',
    'compLayout',
    'siteColors',
    'siteFonts',
    'skin',
    'isMobileView',
    'formatCssValue',
    'experiments',
    'siteFontsSpxResolved',
    'isOneDocMigrated',
  ],
  ({
    compData,
    styleProperties,
    compProps,
    compLayout,
    siteColors,
    siteFonts,
    skin,
    isMobileView,
    isOneDocMigrated,
    formatCssValue,
    siteFontsSpxResolved,
  }) => {
    const { direction } = compData;
    const { align, margin } = styleProperties;

    const newAlign: LogicalAlignment =
      convertPhysicalAlignmentToLogical(align as PhysicalAlignment) ?? align;

    const { spx } = styleProperties;
    const defaultMargin = skin === 'SloopyButton' ? '-4px' : '0px';
    const labelMargin =
      newAlign !== 'center'
        ? {
            [`--margin-${newAlign}`]: formatCssValue(margin, spx),
          }
        : { '--margin-start': defaultMargin, '--margin-end': defaultMargin };

    const brightnessParams =
      skin === 'ScotchTapeButton'
        ? {}
        : getBrightnessCSSVars({ siteColors, styleProperties });

    return {
      ...brightnessParams,
      ...labelMargin,
      '--fnt': getScaledFont(
        {
          styleProperties,
          compLayout: isOneDocMigrated ? {} : compLayout,
          compProps,
          isMobileView,
          siteFonts,
          siteFontsSpxResolved,
        },
        'fnt',
      ),
      direction,
      '--label-align': newAlign,
      '--label-text-align': align,
    };
  },
  [
    withFallbackValues([
      {
        sourceNamespace: 'compProps',
        targetNamespace: 'styleProperties',
        fields: ['margin', 'align'],
      },
    ]),
  ],
);

const stateRefs = withStateRefsValues<keyof SiteButtonStateValues>([
  'reportBi',
]);

export default createComponentMapperModel({ props, css, stateRefs });
